// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const { HireCardImageSelector } = require('components/hire/hireCardImageSelector/hireCardImageSelector');
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');


// @constants
const cardImageIds = [
    'B.501.002.003',
    'B.501.002.022',
    'B.501.002.021',
];
const {
    CREDIT_CARD_REVOLVING_PROCESS,
} = require('constants/flagBasedFeatures');

class HireCardDiamondPackStep2 extends React.Component {

    render() {
        const {
            extraImage,
            immFlagBasedFeatures,
            immHireCardImageSelector,
            immHireCardNameSelector,
        } = this.props;

        const disclaimerPersonalInfoUrl = formatText('disclaimerPersonalInfo-diamondPackLinkUrl');
        const messageContainerClasses = classNames('hire-card-diamond-pack__message-container', {
            'hire-card-diamond-pack__message-container--border-top': immHireCardNameSelector.get('names').size === 1,
            'hire-card-diamond-pack__message-container--hidden': !immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS)
        });

        return (
            <article className="hire-card-diamond-pack__step-two">
                <FormattedText
                    className="hire-card-diamond-pack__step-title"
                    value="hireCardDiamondPack-step2Title"
                />
                <HireCardImageSelector
                    cardImageIds={cardImageIds}
                    extraClass="hire-card-diamond-pack__card-image-selector"
                    extraImage={extraImage}
                    immHireCardImageSelector={immHireCardImageSelector}
                />
                <HireCardNameSelector
                    borderTop={true}
                    immHireCardNameSelector={immHireCardNameSelector}
                />
                <div className={messageContainerClasses}>
                    <OKMessage type="informative">
                        <FormattedText value="disclaimerPersonalInfo-diamondPackMsg" />
                        &nbsp;
                        <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                            <FormattedText value="disclaimerPersonalInfo-diamondPackLinkText" />
                        </OKLink>
                    </OKMessage>
                </div>
            </article>
        );
    }
}

HireCardDiamondPackStep2.propTypes = {
    extraImage: PropTypes.string,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
};

module.exports = HireCardDiamondPackStep2;
